import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=6b2f715e&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=6b2f715e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f715e",
  null
  
)

export default component.exports